import { useAuth } from '@core/hooks/useAuth';
import { useWhoAmI } from '@shared/hooks/useWhoAmI';

const useApp = () => {
  const { isAuthenticated } = useAuth();
  const { getProfile } = useWhoAmI(isAuthenticated);

  const isShownRouterProvider = isAuthenticated && getProfile.isFetching;

  return { isShownRouterProvider } as const;
};

export { useApp };
